import React from 'react';
import { Typography, alpha } from '@mui/material';
import { dsColorNew } from "@palette"

export default function officeColumn() {
    return {
        name: 'nameFilter',
        setBodyCellProps: () => ({
            sx: {
                verticalAlign: 'top',
                p: 1,
                pl: 2,
                backgroundColor: dsColorNew.white,
                borderBottom: `1px solid ${dsColorNew.grayBorder}`,
                boxShadow: `6px 0 8px -6px ${alpha(dsColorNew.textTitle, 0.18)}`,
                userSelect: 'none',
                cursor: 'default',
                position: 'sticky',
                top: 0,
                left: 0,
                zIndex: '150 !important',
            },
        }),
        render: office => <Typography sx={{ textAlign: 'left', pt: 1 }} variant="body2" fontWeight={600} color={dsColorNew.textTitle}>
            {office}
        </Typography>
    };
}
